import { apiRequest } from '@/utils/api-request';
import type { ArtifactDetailResponse } from '@/types/artifacts';

export async function getArtifact(
  orgId: string,
  artifactId: string,
): Promise<ArtifactDetailResponse> {
  const response = await apiRequest<ArtifactDetailResponse>({
    url: `/api/v1/orgs/${orgId}/artifacts/${artifactId}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Failed to fetch artifact');
  return response.data;
}
